import {defineRegistry, get as getStats} from './stats';
import whenComponentIsIdle from './whenComponentIsIdle';
import {whenAllComponentsIdle} from './whenComponentIsIdle';
import createCustomElementFactory from './createCustomElementFactory';
import {
	registerNowResolvedPropsHandler,
	clearNowResolvedPropsHandler
} from './utils/nowResolvedPropsHandler';
import {
	actionTypes as componentActionTypes,
	locations,
	allLogTypes as logTypes
} from '@servicenow/ui-internal';
import {
	COMPONENT_MODE_SUSPEND as SUSPEND,
	COMPONENT_MODE_ACTIVE as ACTIVE,
	COMPONENT_MODE_DETACH as DETACH,
	SHADOW_ROOT_MODE_OPEN as OPEN,
	SHADOW_ROOT_MODE_CLOSED as CLOSED,
	PRIORITY_LEVEL_LOW as LOW,
	PRIORITY_LEVEL_MEDIUM as MEDIUM,
	ARIA_LIVE_REGION_UPDATE_REQUESTED,
	ARIA_LIVE_TRIGGER_ADDITIONS,
	ARIA_LIVE_TRIGGER_ALL,
	ARIA_LIVE_TRIGGER_REMOVALS,
	ARIA_LIVE_TRIGGER_TEXT
} from './constants';
import {
	createUnstableResolvePropertySelectorValue,
	unstableAddRenderOnPropertySelectorValueChange,
	unstableRemoveRenderOnPropertySelectorValueChange
} from './property-selectors';
import {modifierTypes} from './effects';
import {declarativeOperations, getAncestorNode, unstableUpdateCustomElement} from './utils';
import createContext from './context/createContext';
import {politeId, assertiveId} from './accessibility/ariaLiveRegion';
import {CONTEXT_VIEW_KEY} from './symbols';

const componentModes = {
	SUSPEND,
	ACTIVE,
	DETACH
};

const shadowRootModes = {
	OPEN,
	CLOSED
};

const nowPriorityLevels = {
	LOW,
	MEDIUM
};

const componentRegistry = {};

const unstableResolvePropertySelectorValue =
	createUnstableResolvePropertySelectorValue(componentRegistry);

const createCustomElement = createCustomElementFactory({
	componentRegistry
});
const createPresentationalCustomElement = createCustomElementFactory({
	componentRegistry,
	presentational: true
});

const actionTypes = {...componentActionTypes, ARIA_LIVE_REGION_UPDATE_REQUESTED};
const ariaLiveRegionIds = {polite: politeId, assertive: assertiveId};
const contextViewKey = CONTEXT_VIEW_KEY;

const getComponentById = id => componentRegistry[id];
const getComponentInstances = () => ({...componentRegistry});
const ariaLiveRegionTriggers = {
	ARIA_LIVE_TRIGGER_ADDITIONS,
	ARIA_LIVE_TRIGGER_ALL,
	ARIA_LIVE_TRIGGER_REMOVALS,
	ARIA_LIVE_TRIGGER_TEXT
};

defineRegistry(componentRegistry);

window.nowUiFramework = window.nowUiFramework || {};
window.nowUiFramework.core = {getStats};

export {
	registerNowResolvedPropsHandler,
	clearNowResolvedPropsHandler,
	createCustomElement,
	createPresentationalCustomElement,
	actionTypes,
	ariaLiveRegionTriggers,
	logTypes,
	modifierTypes,
	shadowRootModes,
	nowPriorityLevels,
	declarativeOperations,
	locations as errorLocations,
	componentModes,
	ariaLiveRegionIds,
	createContext,
	whenComponentIsIdle,
	whenAllComponentsIdle,
	contextViewKey,
	getAncestorNode,
	getComponentById,
	getComponentInstances,
	getStats,
	// Unstable APIs - Subject to change
	unstableResolvePropertySelectorValue,
	unstableAddRenderOnPropertySelectorValueChange,
	unstableRemoveRenderOnPropertySelectorValueChange,
	unstableUpdateCustomElement
};
